/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import Input from '../../Components/Input';
import { BuilderActionType, BuilderContext } from './state';
import { PageType } from '../../Model/PageData';
import { Info, Layout } from '../../Components/Icon';
import { BuilderMetaPill, BuilderPanel } from './BuilderPanel';
import PageBackgroundEditor from './PageBackgroundEditor';
import PageEventsEditor from './PageEventsEditor';

const PAGE_INFO: { [key: string]: string } = {
    [PageType.SCREEN_DEFAULT]:
        'All system messages will be redirected to this page if no custom pages are provided. Do not add any interactions or timers on this page. This is usually a terminal error state. For better experience, please create pages for the various use cases defined in the "add page" dialog.',
    [PageType.SCREEN_IDLE]:
        'This will be the idle screen when the machine is stocked and ready to be used.',
    [PageType.SCREEN_VENDING]:
        'Users will automatically be redirected from this page to a success or error screen based on machine response.',
    [PageType.SCREEN_VEND_SUCCESS]:
        'Users will automatically be redirected to an idle screen once the machine is ready for the next session. NOTE: this is not the case with legacy build.',
    [PageType.SCREEN_DEVICE_OUT_OF_STOCK]:
        'This screen will be up if there is no inventory left on the device. Machine needs to be restocked before the device is available for vend sessions.',
};

function PageDetails() {
    const { previewPage } = React.useContext(BuilderContext).state;
    const { dispatch } = React.useContext(BuilderContext);

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: BuilderActionType.SET_PAGE_NAME,
            payload: e.target.value,
        });
    };
    if (!previewPage) return null;

    return (
        <div className="space-y-4">
            <BuilderPanel
                title="Page setup"
                icon={<Layout className="h-4 w-4" />}
                description="Organize the current page, then use the element panels below for content-specific styling and actions."
                actions={<BuilderMetaPill>#{previewPage.id}</BuilderMetaPill>}
                bodyClassName="space-y-4"
            >
                <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500">
                    <BuilderMetaPill>
                        CSS selector: #{previewPage.id}
                    </BuilderMetaPill>
                    <span>
                        Add a timer element for pages that should redirect
                        automatically.
                    </span>
                </div>

                {PAGE_INFO[previewPage.id] && (
                    <div className="flex gap-3 rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm leading-6 text-slate-700">
                        <Info className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-600" />
                        <p>{PAGE_INFO[previewPage.id]}</p>
                    </div>
                )}

                <Input
                    name="name"
                    label="Page name"
                    value={previewPage.name}
                    className="w-full"
                    onChange={handleNameChange}
                    autoFocus
                />
            </BuilderPanel>
            <PageBackgroundEditor />
            <PageEventsEditor />
        </div>
    );
}

export default PageDetails;
